module.exports = __webpack_public_path__ + "img/glass.746d5dc6.svg";